import { PdfEntityByAcademicYearList } from 'components/pdfStudent';
import { splitEntitiesByAcademicYear } from 'containers/pdfStudent/utils/splitEntitiesByAcademicYear';
import { useAppSelector, useDataLoad } from 'hooks';
import { IconWidgetCivilUnits } from 'icons/widgets';
import PdfNoDataText from 'portfolio3/features/pdf/components/PdfNoDataText';
import { chosenAcademicYearsListSelector } from 'portfolio3/features/pdf/model/selectors';
import { getDataLoadRequests } from 'utils';

import { civilSectionsSelector } from '../../../../selectors';
import PdfCommonDataEntityContainer from '../common';

import '../index.scss';

const PdfCivilSectionContainer = () => {
  const academicYears = useAppSelector(chosenAcademicYearsListSelector);
  const civilSections = useAppSelector(civilSectionsSelector);
  useDataLoad({ shouldLoad: true, requests: getDataLoadRequests().civilSections });

  const hasData = civilSections.content.length > 0;
  const academicYearData = splitEntitiesByAcademicYear(civilSections, academicYears);

  return (
    <PdfCommonDataEntityContainer title="Кружки" Icon={IconWidgetCivilUnits}>
      {hasData && <PdfEntityByAcademicYearList academicYearData={academicYearData} />}
      {!hasData && <PdfNoDataText />}
    </PdfCommonDataEntityContainer>
  );
};

export default PdfCivilSectionContainer;
